import de from '@translations/de/statusPopup.json';
import en from '@translations/en/statusPopup.json';
import pl from '@translations/pl/statusPopup.json';
import sl from '@translations/sl/statusPopup.json';
import uk from '@translations/uk/statusPopup.json';
import bg from '@translations/bg/statusPopup.json';
import cz from '@translations/cz/statusPopup.json';
import fr from '@translations/fr/statusPopup.json';
import gr from '@translations/gr/statusPopup.json';
import it from '@translations/it/statusPopup.json';
import pr from '@translations/pr/statusPopup.json';
import ru from '@translations/ru/statusPopup.json';
import sk from '@translations/sk/statusPopup.json';
import sp from '@translations/sp/statusPopup.json';
import tr from '@translations/tr/statusPopup.json';
import hu from '@translations/hu/statusPopup.json';
import { ITranslations } from '@/types/common';
import { StatusPopupTransFields } from './types';

export const statusPopupTranslations: ITranslations<StatusPopupTransFields> = {
  name: 'statusPopup',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
